<template>
  <Modal :id="'cmp-add-invoice_projects'" @cancelled="onCancel">
    <template slot="header"
      >{{ $t("choose") }} {{ $t("invoice_project1") }}</template
    >

    <template slot="body">
      <table class="dt-table2 contact-table">
        <thead class="dt-table2--head">
          <tr
            class="dt-table2--row"
            :style="{
              'margin-right': hRowMarginRight,
            }"
          >
            <th class="dt-table2--column">{{ $t("invoice_projects") }}</th>
          </tr>
        </thead>
        <tbody class="dt-table2--body">
          <tr
            class="dt-table2--row"
            v-for="item in invoiceProjectsList"
            :key="item.invoice_project_id"
            @click="(e) => onRowClicked(item)"
          >
            <td class="dt-table2--column">
              {{ item["invoice_project_name"] }}
            </td>
          </tr>
        </tbody>
      </table>
    </template>

    <template slot="options">
      <button class="dt-button s6" @click="onCancel">Cancel</button>
      <!-- <button v-if="genreSearchResult.length==0" class="dt-button v1 s6" @click="onAddGenre">Add Genre</button> -->
    </template>
  </Modal>
</template>

<script>
import { Subject } from "rxjs";

import InputField from "@/plugins/text-field/input-field";

import { waitForAnimation, subscribeSubject } from "@/utility";

import Modal from "../../../../dt-plugins/modal/modal";

import { licenceService } from "../../services/licence.service";
import { format } from "date-fns";
import { invoiceListLDTRoutes } from "../../../accounting/router/routes";

export default {
  props: {},
  components: {
    InputField,

    Modal,
  },
  mixins: [],

  data: function () {
    return {
      invoice_projects: [],
      searchString: "",
      invoiceProjectsSubject$: new Subject(),
      genreSearchResult: [],

      resp: {},

      searchSize: "single",
    };
  },
  mounted: async function () {
    const resData = await licenceService.invoiceProjectsForm(this.external_id);
    console.log("resData:::", resData);

    this.invoice_projects = resData.data.invoice_projects;
    this.resp = resData.data;
    // Artist Subscription
  },
  computed: {
    hRowMarginRight: function () {
      if (this.invoice_projects.length > 380 / 28) {
        return "28px";
      }
    },

    external_id: function () {
      return this.$route.query.external_id;
    },
    licence_line_ids: function () {
      return this.$route.query.licence_line_ids;
    },

    invoiceProjectsList: function () {
      return this.invoice_projects;
    },
  },
  methods: {
    onRowClicked: async function (item) {
      console.log(item, this.resp);

      const param = {
        invoice_language: this.resp?.user?.language || "",
        vat_rate1: item.vat_rate1,
        vat_rate2: item.vat_rate2,
        vat_rate3: 0.0,
        invoice_user_id: this.resp?.user?.user_id || "",
        invoice_date: format(new Date(), "YYYY-MM-DD"),
        invoice_project_id: item.invoice_project_id,
        money_account_id: item.money_account_id,
        payment_method_id: item.payment_method_id,
        invoice_ref_key: item.invoice_ref,
        licence_id: this.resp.licence_id,
        due_days: item.due_days,
        discount_days: item.discount_days,
        discount_percent: item.discount_percent,
      };

      const createdInvoice = await licenceService.licenceLinesToInvoice({
        ...param,
      });

      console.log("::::createdInvoice", createdInvoice);

      //console

      // const payload={
      //   invoice_project_id:item.invoice_project_id ,
      //   licence_lines:this.licence_line_ids,
      //   licence_account_id:this.external_id
      // }
      //this.$emit("create",payload)
      if (createdInvoice.data.invoice_id) {
        this.$router.push({
          name: invoiceListLDTRoutes.names.tab,
          params: {
            invoice_id: createdInvoice.data.invoice_id,
            tab: "overview",
          },
        });
      }

      //invoiceListLDTRoutes

      this.onCancel();
    },
    onCancel: function () {
      this.$emit("cancelled", true);
    },
  },
};
</script>

<style lang="scss" scoped>
.dt-modal--body {
  margin-left: 0px;
}

.contact-search {
  height: 30px;
  width: 290px;
}

.contact-table {
  margin-top: 10px;

  tbody {
    min-height: 380px;
  }
}

.dt-table2 {
  --body-height: 380px;
  --row-height: 28px;

  display: flex;
  flex-direction: column;

  &--head {
  }
  th.dt-table2--column {
    text-align: left;
    color: #828282;
    font-weight: 400;
  }
  &--body {
    background: #f8f8f8;

    display: flex;
    flex-direction: column;

    border: 1px solid var(--sprt-5);
    border-radius: 3px;

    .dt-table2--row {
      border-bottom: 1px solid var(--sprt-7);
    }

    max-height: var(--body-height);
    overflow: auto;
  }
  &--row {
    display: flex;
    flex-direction: row;
    padding: 5px;
    margin: 0px 10px;

    min-height: var(--row-height);
    cursor: pointer;

    &:hover {
      //background: rgb(235, 235, 235);
    }
  }
  &--column {
    flex: 1;

    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.dt-modal--options {
  button {
    &:first-child {
      margin-right: 10px;
    }
    &:last-child {
      margin-left: 0px 10px;
    }
  }
}
</style>